import calcProtectPlanPaidAmt from "./calc_protect_plan_paid_amt";
import { calcProtectPlanSavedAmts } from "./calc_protect_plan_saved_amts";
import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";
import reformatDateToDisplay from "../../../objects/CommonUse/reformatDateToDisplay_function";

export const calcProtectPlanAmts = (gameProtectPlanTrans, gameDate) => {
    const protectPlanTrans = gameProtectPlanTrans.sort((a, b) => (a.protectPlanType + a.planName + a.tranDate > 
        b.protectPlanType + a.planName + b.tranDate) ? 1 : -1);
    const addTrans = protectPlanTrans.filter(elem => elem.tranType === "Add");
  
    const totalAmtPaidArr = calcProtectPlanPaidAmt(addTrans, gameDate);
    const savedTrans = protectPlanTrans.filter(elem => elem.tranType === "AmtSaved");
    const totalAmtsObj = calcProtectPlanSavedAmts(savedTrans, totalAmtPaidArr);
    const totalAmtsArr = totalAmtsObj.totalAmtsArr;
    let textArr = [];
    for (let i=0; i<totalAmtsArr.length; i++){
        const amounts = totalAmtsArr[i];
        if (+amounts.totalPaid === 0 && +amounts.totalSaved === 0){
            // skip
        }else{
            const displayLine = amounts.protectPlanType + " - " + amounts.planName +
                " from " + reformatDateToDisplay(amounts.addFirstDate) + 
                " to " + reformatDateToDisplay(amounts.addLastDate) + 
                " amount paid " + doubleToStringMonthly(amounts.totalPaid) + 
                " amount saved " + doubleToStringMonthly(amounts.totalSaved);
            textArr.push(displayLine);
        }
    }
    const returnObj={textArr: textArr, totalAmtsArr: totalAmtsObj.totalAmtsArr, orphanSavedTrans: totalAmtsObj.savedTrans};
    return returnObj;

}
export default calcProtectPlanAmts;

